/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { trialOnboardingProgressControllerCreate } from "./trialOnboardingProgressControllerCreate";
import { trialOnboardingProgressControllerFindForTrial } from "./trialOnboardingProgressControllerFindForTrial";
import { trialOnboardingProgressControllerUpdate } from "./trialOnboardingProgressControllerUpdate";

export function trialOnboardingProgressService() {
  return { trialOnboardingProgressControllerFindForTrial, trialOnboardingProgressControllerCreate, trialOnboardingProgressControllerUpdate }
}